import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KeyboardService {
  private keyboardOpen: boolean = false;
  private keyboardActive: boolean = false;
  keyboardValue: number | string;
  keyboardOnInputFocus: EventEmitter<any> = new EventEmitter<any>();
  keyboardOnInputChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  public onInputFocus(emitter: EventEmitter<any>, event: any) {
    this.keyboardOnInputFocus.emit({emitter, event});
  }

  public onInputChange(currentField: any, event: any) {
    this.keyboardOnInputChange.emit(event);

    currentField = this.keyboardValue;
  }

  public closeKeyboard() {
    this.keyboardOpen = false;
  }

  public deactiveKeyboard() {
    this.keyboardActive = false;
  }

  public openKeyboard() {
    this.keyboardOpen = true;
  }

  public activeKeyboard() {
    this.keyboardActive = true;
  }

  public keyboardIsOpen() {
    return this.keyboardOpen;
  }

  public keyboardIsActive() {
    return this.keyboardActive;
  }
}
